import { render, staticRenderFns } from "./IndexBdc.vue?vue&type=template&id=51655204&scoped=true"
import script from "./IndexBdc.vue?vue&type=script&lang=js"
export * from "./IndexBdc.vue?vue&type=script&lang=js"
import style0 from "./IndexBdc.vue?vue&type=style&index=0&id=51655204&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51655204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51655204')) {
      api.createRecord('51655204', component.options)
    } else {
      api.reload('51655204', component.options)
    }
    module.hot.accept("./IndexBdc.vue?vue&type=template&id=51655204&scoped=true", function () {
      api.rerender('51655204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/IndexBdc.vue"
export default component.exports